<template>
    <!-- navbar -->
    <nav class="navbar navbar-expand-lg navbar-light" style="background-color:transparent; ">
        <a class="navbar-brand ml-5" href="/" style="color: #ffffff;">

        <!-- <img :src="getImage()"  alt=""  width="50%"/> -->

        <!-- <img class="img-fluid" src="require('/assets/imgs/aruvaa_logo.png')" width="50%"> -->
         <img src="imgs/aruvaa_logo.png" class="img-fluid img_size" alt="" >
        </a>
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>

        <div class="collapse navbar-collapse mr-5" id="navbarSupportedContent">
            <ul class="navbar-nav ml-auto">
                <li class="nav-item ">
                    <!--<a v-bind:href =" url('/') " class="nav-link home-nav-link  nav-link-header">Home</a> -->
                    <a href="/" class="nav-link home-nav-link nav-link-header">Home</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link about-nav-link nav-link-header" href="/support">Support</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link about-nav-link nav-link-header" href="/aboutus">About
                        Us</a>
                </li>
            </ul>
            <form class="form-inline my-2 my-lg-0">
               
              <div v-if="$page.props.user">
                    <a :href="route('dashboard')" class="search-button pt-1 pb-0 pl-2 pr-2" >
                     Account
                    </a>
              </div>


            <div v-else>
                        <a  :href="route('login')"   class="search-button pt-1 pb-0 pl-2 pr-2">
                      Log in   
                        </a>
                        
                    
                        <a v-if="canRegister" :href="route('register')"  class="search-button pt-1 pb-0 pl-2 pr-2">
                                Register
                        </a>
                    
            </div>

                      
            </form>
        </div> 
    </nav>
    <!-- navbar --> 
</template>

<style scoped>
 :root {
        --blue: #0068CA;
        --white: #ffffff;
        --primary: #82C5FF;
        --secondary: #FDC031;
        --black: #333333;
        --input_grey: #d7d7d7;
        --hint_grey: #bfbfbf;
        --pink: #FF4B69;
    }
    * {
        outline: none;
    }
   
.img_size{
    height: auto;
    width: 156px;
}
    /*Scroll - START*/
    /* width */
    ::-webkit-scrollbar {
        width: 5px;
    }
    /* Track */
    ::-webkit-scrollbar-track {
        background: #f1f1f1;
    }
    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: #888;
    }
    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
        background: #555;
    }
    /*Scroll - END*/
    .nav-link-header {
        color: #9c761f !important;
        font-weight: 650 !important;
        font-size: 16px;
    }
    .support-dashboard-container {
        background-color: #0068CA;
        color: var(--white);
    }
    .search-button {
        border: 1px solid #011969;
        font-style: normal;
        margin-left: 4px;
        font-weight: 700;
        background-color: #001969;
        color: white;
        font-size: 15px;
    }
    .search-button:hover {
        text-decoration: none;
        color: #ffffff;
    }
    .category-container {
        font-size: 14px;
        border: 1px solid var(--blue);
        height: 100px;
        color: var(--black);
        transition: 0.2s;
    }
    .category-container:hover {
        box-shadow: 0 0 4px 1px var(--blue);
    }
    .category-container-link:hover {
        text-decoration: none;
    }
   
</style>

<script>
   import { Head, Link } from '@inertiajs/inertia-vue3';
    
    export default {
      
        props: {
            canLogin: Boolean,
            canRegister: Boolean,
          
        },
        
         data() {
        return {
              canRegister:true,
            ///url: '/', 
        }
    }
    }
</script>

